import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateRolesBody, UserV2Output, UserV2Response } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

/**
 * `POST /v1/users/:userId/roles` — met à jour les rôles d'un utilisateur.
 *
 * ⚠️ **WARNING YOHAN** : ce POST **écrase** les rôles existants. Le caller DOIT
 * envoyer la liste **complète** (rôles existants à conserver + ajouts), sinon
 * les rôles non listés sont perdus.
 *
 * Côté UI, `UserRolesModal` garantit ça en présentant des checkboxes
 * pré-cochées pour les rôles actuels et en envoyant le set complet des cases
 * cochées à la submit (aucun delta calculé).
 */
export const useUpdateUserRoles = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, roles }: { userId: string; roles: string[] }) =>
      getExtranetApi().post<UpdateRolesBody, UserV2Response['data']>(`/v1/users/${encodeURIComponent(userId)}/roles`, {
        roles,
      }) as Promise<UserV2Output>,
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({ queryKey: ['extranet', 'users', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['extranet', 'users', 'permissions', userId] });
    },
  });
};
